package pl.decks.personal.components.widgets.iconribbon

import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import pl.decks.personal.styles.SiteLayout


object IconRibbonStylesheet {
    object Vars {
        val size by StyleVariable(40.px)
        val borderRadius by StyleVariable<CSSLengthOrPercentageNumericValue>()
        val borderWidth by StyleVariable<CSSLengthNumericValue>(SiteLayout.Line.Normal)

        val backgroundColor by StyleVariable<Color>(Colors.Transparent)
        val accentColor by StyleVariable<Color>()
        val optionColor by StyleVariable<Color>()

        val phase1Duration by StyleVariable(TransitionDurationVars.VerySlow.value())
        val phase2Duration by StyleVariable(TransitionDurationVars.VerySlow.value())
    }

    object Anims {
        val PushRightAndElevate = Keyframes {
            from { Modifier.padding(leftRight = Vars.size.value() * 0.5).translateY(0.percent) }
            50.percent { Modifier.padding(leftRight = Vars.size.value() * 0.75).translateY(0.percent) }
            to { Modifier.padding(leftRight = Vars.size.value() * 0.75).translateY((-50).percent) }
        }
        val PushRightAndCenter = Keyframes {
            from { Modifier.padding(left = Vars.size.value(), right = Vars.borderRadius.value() * 0.5) }
            50.percent { Modifier.padding(left = Vars.size.value() * 1.25, right = Vars.borderRadius.value() * 0.5) }
            to { Modifier.padding(leftRight = Vars.borderRadius.value() * 0.5) }
        }
    }

    val Ribbon = CssStyle.base {
        Modifier
            .height(Vars.size.value())
            .margin(top = Vars.size.value() * 0.5, bottom = Vars.size.value() * 0.25)
            .setVariable(Vars.borderRadius, Vars.size.value() * 0.5)
            .flexShrink(0)
    }
    val TitleContainer = CssStyle.base {
        Modifier
            .fillMaxSize()
            .padding(
                left = Vars.size.value(),
                right = Vars.borderRadius.value() * 0.5,
            )
            .backgroundColor(Vars.backgroundColor.value())
            .borderRadius(Vars.borderRadius.value())
            .border(Vars.borderWidth.value(), LineStyle.Solid, Vars.accentColor.value())
            .color(Vars.accentColor.value())
            .overflow(Overflow.Hidden)
            .transition {
                property("border-color", "color")
                duration(Vars.phase1Duration.value())
                timingFunction(TransitionTimingFunction.EaseInOut)
            }
    }
    val Title = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .overflow(Overflow.Hidden)
            .textAlign(TextAlign.Center)
            .whiteSpace(WhiteSpace.NoWrap)
            .textOverflow(TextOverflow.Ellipsis)
            .alignContent(AlignContent.Center)
    }
    val OptionsContainer = CssStyle.base {
        Modifier
            .fillMaxSize()
            .padding(leftRight = Vars.size.value() * 0.5)
    }
    val OptionWrap = CssStyle.base {
        Modifier
            .fillMaxHeight()
            .position(Position.Relative)
            .left(0.percent)
            .translateX((-50).percent)
    }
    val OptionButtonVariant = ButtonStyle.addVariant {
        base {
            Modifier
                .fillMaxHeight()
                .color(Vars.optionColor.value())
                .borderRadius(Vars.borderRadius.value())
                .border(Vars.borderWidth.value(), LineStyle.Solid, Vars.optionColor.value())
                .translateY(0.percent)
                .transition {
                    property("transform")
                    duration(TransitionDurationVars.Fast.value())
                    timingFunction(TransitionTimingFunction.EaseInOut)
                }
        }
        hover {
            Modifier.translateY((-10).percent)
        }
    }
}
